import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { RedirectService, UtilsV2Service } from '@app/services';

@Component({
  selector: 'mnf-pi-v2-info-location',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule,],
  templateUrl: './pi-v2-info-location.component.html',
  styleUrl: './pi-v2-info-location.component.scss'
})
export class PiV2InfoLocationComponent implements AfterViewInit, OnChanges {
  @Input() sectionInformation: any;
  @Input() name: string;
  @Input() pid: string | boolean;
  @Input() locationUrl: string;
 
  platformType: 'ios' | 'android' | 'web' = 'web';
  isNativePlatform: boolean = false;

  mapCenter: { lat: number, lng: number };

  mapOptions: google.maps.MapOptions = { mapTypeControl: false, disableDefaultUI: true, scrollwheel: false, scaleControl: false, draggable: false };

  googleMapRoute: string;

  constructor(
    public utilsV2Serv: UtilsV2Service,
    public redirectServ: RedirectService
  ) {
    this.platformType = (typeof cordova !== 'undefined') ? (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ? 'ios' : 'android') : 'web';
    this.isNativePlatform = this.platformType === 'ios' || this.platformType === 'android';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['pid'] && changes['pid'].currentValue) {
      this.pid = changes['pid'].currentValue;
    }
    if(changes['locationUrl'] && changes['locationUrl'].currentValue) {
      this.locationUrl = changes['locationUrl'].currentValue;
    }
    if(changes['sectionInformation'] && changes['sectionInformation'].currentValue) {
      this.sectionInformation = changes['sectionInformation'].currentValue;
      this.googleMapRoute = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.sectionInformation?.locationAddress)}&query_place_id=${this.sectionInformation?.placeId}`;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mapCenter = { 
        lat: Number(this.sectionInformation?.locationLat), 
        lng: Number(this.sectionInformation?.locationLng) 
      };
  
      this.googleMapRoute = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.sectionInformation?.locationAddress)}&query_place_id=${this.sectionInformation?.placeId}`;
    }, 700);
  }
  
}
